export default {"src":"/_next/static/media/0xb986f3a2d91d3704dc974a24fb735dcc5e3c1e70.3bd8ca5a.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};